import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { MessageService } from "primeng/api";
import { ConfigService } from "src/app/configurations/services/config.service";
import { MyTasksService } from "src/app/my-task/services/my-tasks.service";
import { PatientsService } from "src/app/patients/services/patients.service";
import { SharedMethodsComponent } from "../shared-methods/shared-methods.component";

@Component({
  selector: "app-patient-address-details",
  templateUrl: "./patient-address-details.component.html",
  styleUrls: ["./patient-address-details.component.css"],
  providers: [MessageService],
})
export class PatientAddressDetailsComponent implements OnInit {
  addressForm: any;
  AllEditAddress: any;
  editPatientsAddress: boolean = false;
  loader: boolean = false;
  addressFormSubmitted: boolean = false;
  patientDetails: any;
  PatientID: any;
  ArchieveFlagValue;
  // patientDetails: any;

  constructor(
    private patientService: PatientsService,
    private fb: FormBuilder,
    private myTaskService: MyTasksService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private configService: ConfigService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.PatientID = this.configService.dec(params["PatientID"]);
      this.ArchieveFlagValue = params["ArchiveFlag"];
    });
    this.GetPatientDetails();
    this.AddressformInitialize();
  }

  AddressformInitialize() {
    this.addressForm = this.fb.group({
      PostCode: new FormControl("", Validators.required),
      AddressLine1: new FormControl("", Validators.required),
      AddressLine2: new FormControl(""),
      AddressLine3: new FormControl(""),
      Addresses: new FormControl(""),
      City: new FormControl(""),
      County: new FormControl(""),
    });
  }

  FindEditAddress() {
    var postcode = this.addressForm.controls["PostCode"].value;
    if (postcode) {
      this.myTaskService.GetAddresses(postcode).subscribe((res) => {
        this.AllEditAddress = res["addresses"];
      });
    } else {
    }
  }

  getEditAddress(e) {
    var result = e.target.value.split(", ");
    this.addressForm.patchValue({
      AddressLine1: result[0],
      AddressLine2: result[1],
      AddressLine3: result[2],
      City: result[result.length - 2] + " " + result[result.length - 3],
      County: result[result.length - 1],
    });
  }

  editPatientAddress() {
    this.editPatientsAddress = true;
  }

  savePatientAddress() {
    this.loader = true;
    this.addressFormSubmitted = true;
    if (!this.addressForm.valid) {
      this.loader = false;
      return true;
    } else {
      var PatientData = {
        AddressID: this.patientDetails.AddressID,
        AddressLine1: this.addressForm.value.AddressLine1,
        AddressLine2: this.addressForm.value.AddressLine2,
        AddressLine3: this.addressForm.value.AddressLine3,
        City: this.addressForm.value.City,
        County: this.addressForm.value.County,
        PostCode: this.addressForm.value.PostCode,
        PatientID: this.PatientID,
      };
      this.patientService.UpdatePatientAddress(PatientData).subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            this.ShowToast(
              "success",
              "success",
              "Patient's address has been updated successfully"
            );
            this.GetPatientDetails();
            this.cancelPatientAddress();
          } else {
            this.loader = false;
            this.ShowToast(
              "warn",
              "Warning",
              "Unable to update patient's address. Please try again"
            );
          }
        },
        (err) => {
          this.loader = false;
          this.ShowToast(
            "error",
            "Error",
            "Unable to update patient's address. Please try again"
          );
        }
      );
    }
  }

  cancelPatientAddress() {
    this.editPatientsAddress = false;
    this.addressForm.reset();
    this.addressFormSubmitted = false;
    this.AddressformInitialize();
  }

  ShowToast(type, title, desc) {
    this.messageService.add({
      severity: type,
      summary: title,
      detail: desc,
    });
  }

  GetPatientDetails() {
    this.loader = true;
    this.patientService
      .getPatientDetails(
        this.PatientID,
        this.ArchieveFlagValue ? this.ArchieveFlagValue : 0
      )
      .subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            res["data"] = JSON.parse(this.configService.dec(res["data"]));
            if (res["data"] && res["data"].length > 0) {
              this.patientDetails = res["data"][0];
            } else {
              this.patientDetails = [];
            }
          } else {
            this.loader = false;
            this.patientDetails = [];
          }
        },
        (err) => {
          this.loader = false;
          this.patientDetails = [];
        }
      );
  }
}
